import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';

import { CCAuthService } from '@heidelberg/control-center-frontend-integration/auth';
import { CloudSessionService } from '@data-terminal/data-access/session-service';
import { isToday } from '@data-terminal/utils/date';
import { ROUTE_PATH } from '@data-terminal/shared-models/navigation';

@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class TransitionService {
    private readonly router = inject(Router);
    private readonly cloudSessionService = inject(CloudSessionService);
    private readonly ccAuthService = inject(CCAuthService);

    public get shouldDisplayWelcomeScreen$(): Observable<boolean> {
        const lastSessionUpdateDate = this.cloudSessionService.getSessionData()?.updatedAt;

        if (!lastSessionUpdateDate) {
            return of(true);
        }

        return of(!isToday(new Date(lastSessionUpdateDate)));
    }

    public navigateToWelcomePage(): void {
        const orgId = this.ccAuthService.getCurrentMembership()?.organizationId;
        this.router.navigateByUrl(`${orgId}/${ROUTE_PATH.welcome}`);
    }

    public navigateToFarewellPage(shiftEnd = false): void {
        const orgId = this.ccAuthService.getCurrentMembership()?.organizationId;
        const parameter = shiftEnd ? '?shiftEnd=true' : '';
        this.router.navigateByUrl(`${orgId}/${ROUTE_PATH.farewell}${parameter}`);
    }
}
